/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HistoryDto } from '../models/history-dto';

@Injectable({
  providedIn: 'root',
})
export class GetUserHistoryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUserHistory
   */
  static readonly GetUserHistoryPath = '/history';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserHistory$Response(params?: {
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<Array<HistoryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GetUserHistoryService.GetUserHistoryPath, 'get');
    if (params) {
      rb.query('page', params.page, {"explode":false});
      rb.query('size', params.size, {"explode":false});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HistoryDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserHistory(params?: {
    page?: number;
    size?: number;
  }): Observable<Array<HistoryDto>> {

    return this.getUserHistory$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HistoryDto>>) => r.body as Array<HistoryDto>)
    );
  }

}
